// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const SeeYouSoonSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.white}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="29"
      viewBox="0 0 44 29"
      role="presentation"
    >
      <g fill="#FCFBFC" fillRule="evenodd">
        <path d="M33.527 1.84v-.46c0-.76-.622-1.38-1.38-1.38h-3.8c-.76 0-1.38.62-1.38 1.38v.544C21.237 3.45 17 8.684 17 14.888c0 7.397 6.018 13.415 13.415 13.415 7.397 0 13.415-6.018 13.415-13.415 0-6.325-4.402-11.64-10.303-13.047zm-1.49 13.513a1.216 1.216 0 01-1.668.439l-6.81-3.967a1.218 1.218 0 01-.44-1.667 1.218 1.218 0 011.667-.44l6.81 3.965c.582.34.78 1.086.44 1.668z" />
        <path
          stroke="#FCFBFC"
          d="M3.89 10.778h9.332a.89.89 0 00.89-.89.89.89 0 00-.89-.888H3.89a.89.89 0 100 1.778zm8.22 5.112a.888.888 0 00-.888-.89H1.89a.89.89 0 100 1.778h9.332a.89.89 0 00.89-.89zm2 6a.888.888 0 00-.888-.89H3.89a.89.89 0 100 1.778h9.332a.89.89 0 00.89-.89z"
        />
      </g>
    </svg>
  </SvgContainer>
);

SeeYouSoonSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default SeeYouSoonSvg;
